import { useState, useEffect } from "react";
import { Drawer, Table, Tag, Statistic, Row, Col, Divider, Button, Popconfirm, notification } from "antd";
import axios from "axios";

import endpoints from "../../../../utils/endoinpts";

const columns = [
  {
    title: "Nome",
    dataIndex: "name",
  },
  {
    title: "E-mail",
    dataIndex: "email",
  },
  {
    title: "Tipo",
    dataIndex: "recipient_type",
    render: (type) => (type === "guest" ? "Convidado(a)" : "Sócio(a)"),
  },
  {
    title: "Estado",
    dataIndex: "status",
    render: (status) => <Tag color={status === "success" ? "green" : "red"}>{status === "success" ? "Enviado" : "Falhou"}</Tag>,
  },
  {
    title: "Detalhe do erro",
    dataIndex: "error_message",
  },
];

export default function EmailLogs({ data, open, close }) {
  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    if (open && data) {
      handleGetData();
    }
  }, [open, data]);

  function handleGetData() {
    setIsLoading(true);
    axios
      .get(endpoints.communications.emailLogs, { params: { id: data.id } })
      .then((res) => {
        setLogs(res.data.map((item) => ({ ...item, key: item.id })));
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  function handleResendFailed() {
    setIsResending(true);
    axios
      .post(endpoints.communications.resendFailed, { data: { id: data.id } })
      .then((res) => {
        notification.success({
          message: "Reenvio iniciado",
          description: `A reenviar para ${res.data.count} destinatário(s) que falharam. Os envios são feitos a um ritmo controlado (cerca de 20 por minuto); consulte o registo daqui a alguns minutos.`,
        });
        setIsResending(false);
        close();
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Não foi possível reenviar",
          description: (err.response && err.response.data && err.response.data.message) || "Tente novamente daqui a pouco.",
        });
        setIsResending(false);
      });
  }

  let successCount = logs.filter((item) => item.status === "success").length;
  let errorCount = logs.filter((item) => item.status === "error").length;

  return (
    <Drawer title={`Registo de envios - ${data ? data.subject : ""}`} width={800} onClose={close} open={open}>
      {data && data.status === "pending" ? (
        <p>Esta comunicação ainda não foi enviada, por isso ainda não existe registo de envio.</p>
      ) : (
        <>
          <Row className="mb-4">
            <Col span={8}>
              <Statistic title="Total de destinatários" value={logs.length} />
            </Col>
            <Col span={8}>
              <Statistic title="Enviados com sucesso" value={successCount} valueStyle={{ color: "#3f8600" }} />
            </Col>
            <Col span={8}>
              <Statistic title="Falharam" value={errorCount} valueStyle={{ color: errorCount > 0 ? "#cf1322" : undefined }} />
            </Col>
          </Row>
          {errorCount > 0 && data && data.status === "sent" && (
            <Popconfirm
              title={`Reenviar a comunicação para os ${errorCount} destinatários que falharam?`}
              description="Quem já recebeu não volta a receber."
              okText="Reenviar"
              cancelText="Cancelar"
              onConfirm={handleResendFailed}
            >
              <Button type="primary" size="large" loading={isResending}>
                Reenviar aos que falharam ({errorCount})
              </Button>
            </Popconfirm>
          )}
          <Divider />
          <Table columns={columns} dataSource={logs} loading={isLoading} />
        </>
      )}
    </Drawer>
  );
}
